<style>
</style>
<template>
  <div class="passagewayList-box">
    <p class="title">通道管理&nbsp;&nbsp;<strong>[ 短信通道 ]</strong></p>
    <!-- <div class="addBtn">
      <el-button type="primary" style="padding:8px 12px" @click="addPassageway">
        <i class="el-icon-circle-plus"></i>&nbsp;添加通道
      </el-button>
    </div> -->
    <el-table :data="passagewayData" border>
      <el-table-column label="通道名称" prop="smsPlatformName"></el-table-column>
      <el-table-column label="通道类型" prop="platformType"></el-table-column>
      <el-table-column label="优先级" prop="priorLevel"></el-table-column>
      <el-table-column label="短信总额" prop="smsTotal"></el-table-column>
      <el-table-column label="短信余额" prop="smsBanlance"></el-table-column>
      <el-table-column label="富信总额" prop="smsFuxinTotal"></el-table-column>
      <el-table-column label="富信余额" prop="smsFuxinBalance"></el-table-column>
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <span class="text-blue pointer" @click="revisePassageway(scope.row)">修改</span>
        </template>
      </el-table-column>
    </el-table>
    <creat v-if="show" @passagewayClose='close' :data='reviseData'></creat>
  </div>
</template>
<script>
import api from '../../server/api.js'
import creat from '../../components/passageway/creatPassageway'
export default {
  name: "passagewayList",
  data(){
    return{
      passagewayData: [],
      show: false,
      reviseData: null,
    };
  },
  created(){
    this.getCustomerList();
  },
  methods: {
    getCustomerList(){//获取通道列表
      api.getPlatformList({data:{}}).then(res => {
        this.passagewayData = res.data;
      })
    },
    revisePassageway(row){//修改通道内容
      this.show = true;
      this.reviseData = row;
    },
    close(){//关闭新增
      this.show = false;
      this.getCustomerList();
    },
    sizeChange(v){//切换显示条数
      this.pageSize = v;
      this.getCustomerList();
    },
    currentChange(v){//切换页数
      this.pageNum = v;
      this.getCustomerList();
    }
  },
  components: {
    creat
  }
}
</script>
  




// WEBPACK FOOTER //
// src/view/passageway/passagewayMsg.vue